import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** Shown when a list has no rows — distinct from a failed load, which uses an Alert. */
export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-14', className)}>
      <span className="bg-canvas text-muted grid size-12 place-items-center rounded-full">
        <Icon className="size-6" aria-hidden />
      </span>
      <div className="text-center">
        <p className="text-ink text-sm font-medium">{title}</p>
        {description ? <p className="text-muted mt-1 text-sm">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}
